import React from 'react';
import { Typography } from '@mui/material';
import { RouterLink } from '@/navigation';
import { Link } from '@peerless/ui-shared';

export type ProductLinkProps = React.PropsWithChildren<{
  sku: string;
  title: string;
  className?: string;
}>;

export function ProductLink({ title, sku, className, children }: ProductLinkProps) {
  if (children) {
    return (
      <RouterLink
        style={{ textDecoration: 'none' }}
        className={className}
        href={`/products/${sku}`}
      >
        {children}
      </RouterLink>
    );
  }

  return (
    <Link className={className} color="secondary" href={`/products/${sku}`}>
      <Typography variant="body1">{title}</Typography>
    </Link>
  );
}
